import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { GetTestDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';

export const ExamOnline: React.FC<{
  examId?: string;
  tests?: GetTestDto[];
  endDate?: Date | null;
  online: boolean;
  setRefresh?: () => void;
  className?: string;
}> = ({ examId, tests, online, endDate, setRefresh, className }) => {
  const spd = useSpdCore();

  const onClickExamOnline = async () => {
    if (examId) {
      spd.exams
        .setOnline(examId)
        .then(() => {
          if (setRefresh) {
            setRefresh();
          }
        })
        .catch(async error => {
          const err = await responseErrors(error);
          toast.error(`Badanie nie zostało ustawione jako online. ${err}`);
        });
    }
  };

  return (
    <>
      {examId &&
        tests &&
        tests?.length > 0 &&
        !tests.some(o => !o.onlineOption) &&
        !online &&
        !endDate && (
          <ConfirmationButton
            className={className}
            confirmation="Czy na pewno badany może wykonać to badanie zdalnie? Zostanie wysłana wiadomość z pinem do badanego."
            variant="outline-danger"
            onOK={onClickExamOnline}
          >
            Ustaw badanie jako online
          </ConfirmationButton>
        )}
      <ToastContainer />
    </>
  );
};
